<template>
  <v-container>
    <material-card>
      <v-layout slot="header" px-3>
        <v-flex my-4 pl-4 title align-center justify-center>Lista punktów odbioru karty</v-flex>

        <v-spacer />

        <v-flex>
          <search />
        </v-flex>
      </v-layout>

      <v-layout text-xs-right>
        <v-flex>
          <check-permission permissions="COLLECTION_POINT.ADD">
            <v-btn large color="error" @click="showAddModal">DODAJ PUNKT ODBIORU</v-btn>
          </check-permission>
        </v-flex>
      </v-layout>

      <material-table
        entity-type="collection_point"
        :headers="headers"
        :actions="actions"
        :items="list"
        :total-count="count"
        @edit="showEditModal($event.id)"
        @delete="showDeleteDialog($event.id)"
      />

      <material-dialog
        :id="idToDelete"
        title="Potwierdź usunięcie"
        text="Czy na pewno chcesz usunąć punkt odbioru?"
        :show="!!idToDelete"
        @close="hideDeleteDialog"
        @confirm="remove"
      />
    </material-card>

    <modal :show="showModal" :id-to-edit="idToEdit" @close="hideModal" @saved="modelSaved" />
  </v-container>
</template>

<script>
import { addressCityFirst, State, StateTranslation } from '@witkac/kartamiejska-shared';

import Modal from '@/components/collectionPoint/EditModal';
import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import MaterialTable from '@/components/material/Table';
import Search from '@/components/material/table/Search';
import { listMixin } from '@/mixins/list';
import { DELETE_ACTION, EDIT_ACTION } from '@/utils/actions';

// @vuese
// Wyświetlanie listy punktów odbioru karty
// @group CollectionPoint
export default {
  filters: {
    addressCityFirst
  },
  components: {
    MaterialCard,
    MaterialTable,
    MaterialDialog,
    Modal,
    Search
  },
  mixins: [
    listMixin('collectionPoint', {
      added: 'Dodano punkt odbioru.',
      addError: 'Nie udało się dodać punktu odbioru.',
      updated: 'Zaktualizowano punkt odbioru.',
      updateError: 'Nie udało się zaktualizować punktu odbioru.',
      deleted: 'Usunięto punkt odbioru.',
      deleteError: 'Nie udało się usunąć punktu odbioru.',
      listError: 'Nie udało się pobrać listy punktów odbioru.'
    })
  ],
  data() {
    return {
      headers: [
        { text: 'Nazwa punktu odbioru', value: 'name' },
        {
          text: 'Status',
          value: 'state',
          orderBy: 'state',
          render: item => StateTranslation[State[item.state]]
        },
        {
          text: 'Adres',
          sortable: true,
          value: 'street',
          orderBy: ['street', 'homeNumber', 'localNumber', 'postalCode', 'city'],
          render: item => addressCityFirst(item)
        }
      ],
      actions: [DELETE_ACTION, EDIT_ACTION]
    };
  },
  watch: {
    '$store.state.modalClose.confirm'(val) {
      if (val) {
        this.hideModal();
        this.$store.dispatch('resetConfirmState');
      }
    }
  },
  methods: {
    // @vuese
    // Obsługa po edycji, przeładowanie listy
    modelSaved() {
      this.reloadList(this.$route);
    }
  }
};
</script>
